import * as React from 'react';
import { cn } from '../../lib/cn';

/**
 * Badge — a compact status label: a role ("Inhaber"), a state ("Pausiert", "Ausstehend").
 * Text, never colour alone, carries the meaning; `tone` only reinforces it.
 */
export type BadgeTone = 'neutral' | 'warning' | 'success' | 'info' | 'danger';

const tones: Record<BadgeTone, string> = {
  neutral: 'tw:bg-muted tw:text-foreground',
  warning: 'tw:bg-[var(--color-warning-100)] tw:text-[var(--color-warning-700)]',
  success: 'tw:bg-[var(--color-success-100)] tw:text-[var(--color-success-700)]',
  info: 'tw:bg-[var(--color-info-100)] tw:text-[var(--color-info-700)]',
  danger: 'tw:bg-[var(--color-error-100)] tw:text-[var(--color-error-700)]',
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(({ tone = 'neutral', className, ...props }, ref) => (
  <span
    ref={ref}
    data-tone={tone}
    className={cn(
      'tw:inline-flex tw:items-center tw:gap-1 tw:whitespace-nowrap tw:rounded-full tw:px-2 tw:py-0.5 tw:font-sans tw:text-xs tw:font-medium',
      tones[tone],
      className
    )}
    {...props}
  />
));
Badge.displayName = 'Badge';
